import React, { useEffect, Fragment } from 'react';
import { Form, Row, Col, Container, Card } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import { object, string } from '../../Helpers/Validators/customValidators';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import { MultiSelectInput, SelectInput, StyledRadioInput } from "../../Helpers/Inputs/index";
import { ThemeProvider, createTheme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import InputTheme from './Helpers/InputTheme';
import FamilyIcon from "../../../icons/FamilyMembers.svg";
import SvgIcon from "@material-ui/core/SvgIcon";
import getFamilyMembers from "../../Helpers/Lists/FamilyMembers";
import getAgeClasses from "../../Helpers/Lists/AgeClasses";

import "./FamilyHistory.scss";

const useStyles = makeStyles(theme => ({
  lightBackground: {
    backgroundColor: `${theme.palette.primary.main}16`,
  },
}));

export default function FamilyHistory(props) {

  const classes = useStyles();

  const { register, errors, handleSubmit, setValue, triggerValidation } = useForm({
    validationSchema: FamilyHistory.ValidationSchema,
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });

  const handleValueChange = (field, value) => {
    setValue(field, value);
    props.onFieldChange(field, value);
    triggerValidation(field);
  };

  useEffect(() => {
    // manually register fields for validation that don't play nice with react-hook-form register
    //Cancer
    register({ name: 'familyMember' });
    setValue('familyMember', props.formState.familyMember);

    register({ name: 'diagnosedWithCancer' });
    setValue('diagnosedWithCancer', props.formState.diagnosedWithCancer);

    register({ name: 'familyMembersDiagnosedWithCancer' });
    setValue('familyMembersDiagnosedWithCancer', props.formState.familyMembersDiagnosedWithCancer);

    register({ name: 'fatherPassedAwayByCancer' });
    setValue('fatherPassedAwayByCancer', props.formState.fatherPassedAwayByCancer);

    register({ name: 'fatherAgeOfDeathByCancer' });
    setValue('fatherAgeOfDeathByCancer', props.formState.fatherAgeOfDeathByCancer);

    register({ name: 'fatherAgeOfDiagnosisForCancer' });
    setValue('fatherAgeOfDiagnosisForCancer', props.formState.fatherAgeOfDiagnosisForCancer);

    register({ name: 'motherPassedAwayByCancer' });
    setValue('motherPassedAwayByCancer', props.formState.motherPassedAwayByCancer);

    register({ name: 'motherAgeOfDeathByCancer' });
    setValue('motherAgeOfDeathByCancer', props.formState.motherAgeOfDeathByCancer);

    register({ name: 'motherAgeOfDiagnosisForCancer' });
    setValue('motherAgeOfDiagnosisForCancer', props.formState.motherAgeOfDiagnosisForCancer);

    register({ name: 'siblingPassedAwayByCancer' });
    setValue('siblingPassedAwayByCancer', props.formState.siblingPassedAwayByCancer);

    register({ name: 'siblingAgeOfDeathByCancer' });
    setValue('siblingAgeOfDeathByCancer', props.formState.siblingAgeOfDeathByCancer);

    register({ name: 'siblingAgeOfDiagnosisForCancer' });
    setValue('siblingAgeOfDiagnosisForCancer', props.formState.siblingAgeOfDiagnosisForCancer);


    // Cardiovascular
    register({ name: 'diagnosedWithCardiovascular' });
    setValue('diagnosedWithCardiovascular', props.formState.diagnosedWithCardiovascular);

    register({ name: 'familyMembersDiagnosedWithCardiovascular' });
    setValue('familyMembersDiagnosedWithCardiovascular', props.formState.familyMembersDiagnosedWithCardiovascular);

    register({ name: 'fatherPassedAwayByCardiovascular' });
    setValue('fatherPassedAwayByCardiovascular', props.formState.fatherPassedAwayByCardiovascular);

    register({ name: 'fatherAgeOfDeathByCardiovascular' });
    setValue('fatherAgeOfDeathByCardiovascular', props.formState.fatherAgeOfDeathByCardiovascular);

    register({ name: 'fatherAgeOfDiagnosisForCardiovascular' });
    setValue('fatherAgeOfDiagnosisForCardiovascular', props.formState.fatherAgeOfDiagnosisForCardiovascular);

    register({ name: 'motherPassedAwayByCardiovascular' });
    setValue('motherPassedAwayByCardiovascular', props.formState.motherPassedAwayByCardiovascular);

    register({ name: 'motherAgeOfDeathByCardiovascular' });
    setValue('motherAgeOfDeathByCardiovascular', props.formState.motherAgeOfDeathByCardiovascular);

    register({ name: 'motherAgeOfDiagnosisForCardiovascular' });
    setValue('motherAgeOfDiagnosisForCardiovascular', props.formState.motherAgeOfDiagnosisForCardiovascular);

    register({ name: 'siblingPassedAwayByCardiovascular' });
    setValue('siblingPassedAwayByCardiovascular', props.formState.siblingPassedAwayByCardiovascular);

    register({ name: 'siblingAgeOfDeathByCardiovascular' });
    setValue('siblingAgeOfDeathByCardiovascular', props.formState.siblingAgeOfDeathByCardiovascular);

    register({ name: 'siblingAgeOfDiagnosisForCardiovascular' });
    setValue('siblingAgeOfDiagnosisForCardiovascular', props.formState.siblingAgeOfDiagnosisForCardiovascular);

  }, [register]);

  const onSubmit = () => {
    props.onNext();
  };

  return (
    <ThemeProvider theme={(theme) => createTheme({
      ...theme,
      ...InputTheme(),
    })}>
      <Container className="personalize-step">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="justify-content-center family-history">
            <Col lg={4} md={8} sm={12}>
              <Row className="justify-content-center pt-2">
                <div className={`icon-container ${classes.lightBackground}`}>
                    <SvgIcon component={FamilyIcon} color="primary" fontSize="large" />
                </div>
              </Row>
              <Row className="justify-content-center mainTitle">
                <h4>Family Medical History</h4>
              </Row>
              {/* Cancer */}
              <Form.Group>
                <p className="formElementTitle">I have had a parent or sibling who was diagnosed with cancer prior to age 70.</p>
                <StyledRadioInput
                  name="diagnosedWithCancer"
                  id="diagnosedWithCancer"
                  value={props.formState.diagnosedWithCancer}
                  options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                  onChange={e => handleValueChange('diagnosedWithCancer', e)}
                  errors={errors.diagnosedWithCancer}
                  isWhiteBackground={true}
                  isBlankIcon={true}
                />
              </Form.Group>

              {props.formState.diagnosedWithCancer === "Yes" &&
                <Fragment>
                  <Form.Group>
                    <MultiSelectInput
                      name="familyMembersDiagnosedWithCancer"
                      id="familyMembersDiagnosedWithCancer"
                      value={props.formState.familyMembersDiagnosedWithCancer ? props.formState.familyMembersDiagnosedWithCancer : []}
                      onChange={(e) => handleValueChange('familyMembersDiagnosedWithCancer', e.target.value)}
                      label="Family Member(s) Diagnosed"
                      inputRef={register}
                      selectOptions={getFamilyMembers()}
                      errors={errors && errors.familyMembersDiagnosedWithCancer}
                    />
                  </Form.Group>

                  {(props.formState.familyMembersDiagnosedWithCancer && props.formState.familyMembersDiagnosedWithCancer.includes("Father")) &&
                    <Card className="pb-0 pt-3 px-3 mb-3">
                      <p className="formElementTitle">My father Passed away from cancer</p>
                      <Form.Group>
                        <StyledRadioInput
                          name="fatherPassedAwayByCancer"
                          id="fatherPassedAwayByCancer"
                          value={props.formState.fatherPassedAwayByCancer}
                          options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                          onChange={e => handleValueChange('fatherPassedAwayByCancer', e)}
                          errors={errors && errors.fatherPassedAwayByCancer}
                          isBlankIcon={true}
                        />
                      </Form.Group>

                      {props.formState.fatherPassedAwayByCancer === "Yes" &&
                        <Form.Group>
                          <SelectInput
                            name="fatherAgeOfDeathByCancer"
                            id="fatherAgeOfDeathByCancer"
                            label="Father's Age of Death"
                            value={props.formState.fatherAgeOfDeathByCancer}
                            onChange={e => handleValueChange('fatherAgeOfDeathByCancer', e.target.value)}
                            selectOptions={getAgeClasses()}
                            errors={errors && errors.fatherAgeOfDeathByCancer}
                            inputRef={register}
                          />
                        </Form.Group>
                      }

                      {props.formState.fatherPassedAwayByCancer === "No" &&
                        <Form.Group>
                          <SelectInput
                            name="fatherAgeOfDiagnosisForCancer"
                            id="fatherAgeOfDiagnosisForCancer"
                            label="Father's Age of Diagnosis"
                            value={props.formState.fatherAgeOfDiagnosisForCancer}
                            onChange={e => handleValueChange('fatherAgeOfDiagnosisForCancer', e.target.value)}
                            inputRef={register}
                            errors={errors && errors.fatherAgeOfDiagnosisForCancer}
                            selectOptions={getAgeClasses()}
                          />
                        </Form.Group>
                      }
                    </Card>
                  }

                  {(props.formState.familyMembersDiagnosedWithCancer && props.formState.familyMembersDiagnosedWithCancer.includes("Mother")) &&
                    <Card className="pb-0 pt-3 px-3  mb-3">
                      <p className="formElementTitle"> My mother Passed away from cancer</p>
                      <Form.Group>
                        <StyledRadioInput
                          name="motherPassedAwayByCancer"
                          id="motherPassedAwayByCancer"
                          value={props.formState.motherPassedAwayByCancer}
                          options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                          onChange={e => handleValueChange('motherPassedAwayByCancer', e)}
                          errors={errors && errors.motherPassedAwayByCancer}
                          isBlankIcon={true}
                        />
                      </Form.Group>
                      {props.formState.motherPassedAwayByCancer === "Yes" &&
                        <Form.Group>
                          <SelectInput
                            name="motherAgeOfDeathByCancer"
                            id="motherAgeOfDeathByCancer"
                            label="Mother's Age of Death"
                            value={props.formState.motherAgeOfDeathByCancer}
                            onChange={e => handleValueChange('motherAgeOfDeathByCancer', e.target.value)}
                            inputRef={register}
                            errors={errors && errors.motherAgeOfDeathByCancer}
                            selectOptions={getAgeClasses()}
                          />
                        </Form.Group>
                      }

                      {props.formState.motherPassedAwayByCancer === "No" &&
                        <Form.Group>
                          <SelectInput
                            name="motherAgeOfDiagnosisForCancer"
                            id="motherAgeOfDiagnosisForCancer"
                            label="Mother's Age of Diagnosis"
                            value={props.formState.motherAgeOfDiagnosisForCancer}
                            onChange={e => handleValueChange('motherAgeOfDiagnosisForCancer', e.target.value)}
                            inputRef={register}
                            errors={errors && errors.motherAgeOfDiagnosisForCancer}
                            selectOptions={getAgeClasses()}
                          />
                        </Form.Group>
                      }
                    </Card>
                  }

                  {(props.formState.familyMembersDiagnosedWithCancer && props.formState.familyMembersDiagnosedWithCancer.includes("Sibling")) &&
                    <Card className="pb-0 pt-3 px-3  mb-3">
                      <p className="formElementTitle">My sibling Passed away from cancer</p>
                      <Form.Group>
                        <StyledRadioInput
                          name="siblingPassedAwayByCancer"
                          id="siblingPassedAwayByCancer"
                          value={props.formState.siblingPassedAwayByCancer}
                          options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                          onChange={e => handleValueChange('siblingPassedAwayByCancer', e)}
                          errors={errors && errors.siblingPassedAwayByCancer}
                          isBlankIcon={true}
                        />
                      </Form.Group>

                      {props.formState.siblingPassedAwayByCancer === "Yes" &&
                        <Form.Group>
                          <SelectInput
                            name="siblingAgeOfDeathByCancer"
                            id="siblingAgeOfDeathByCancer"
                            label="Sibling's Age of Death"
                            value={props.formState.siblingAgeOfDeathByCancer}
                            onChange={e => handleValueChange('siblingAgeOfDeathByCancer', e.target.value)}
                            inputRef={register}
                            errors={errors && errors.siblingAgeOfDeathByCancer}
                            selectOptions={getAgeClasses()}
                          />
                        </Form.Group>
                      }

                      {props.formState.siblingPassedAwayByCancer === "No" &&
                        <Form.Group>
                          <SelectInput
                            name="siblingAgeOfDiagnosisForCancer"
                            id="siblingAgeOfDiagnosisForCancer"
                            aria-label="siblingAgeOfDiagnosisForCancer"
                            label="Sibling's Age of Diagnosis"
                            value={props.formState.siblingAgeOfDiagnosisForCancer}
                            onChange={e => handleValueChange('siblingAgeOfDiagnosisForCancer', e.target.value)}
                            inputRef={register}
                            errors={errors && errors.siblingAgeOfDiagnosisForCancer}
                            selectOptions={getAgeClasses()}
                          />
                        </Form.Group>
                      }
                    </Card>
                  }
                </Fragment>
              }

              {/* Cardiovascular */}
              <Form.Group>
                <p className="formElementTitle">I have had a parent or sibling diagnosed with cardiovascular/heart disease prior to age 70.</p>
                <StyledRadioInput
                  name="diagnosedWithCardiovascular"
                  id="diagnosedWithCardiovascular"
                  value={props.formState.diagnosedWithCardiovascular}
                  options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                  onChange={e => handleValueChange('diagnosedWithCardiovascular', e)}
                  errors={errors && errors.diagnosedWithCardiovascular}
                  isWhiteBackground={true}
                  isBlankIcon={true}
                />
              </Form.Group>

              {props.formState.diagnosedWithCardiovascular === "Yes" &&
                <Fragment>
                  <Form.Group>
                    <MultiSelectInput
                      name="familyMembersDiagnosedWithCardiovascular"
                      id="familyMembersDiagnosedWithCardiovascular"
                      value={props.formState.familyMembersDiagnosedWithCardiovascular ? props.formState.familyMembersDiagnosedWithCardiovascular : []}
                      onChange={(e) => handleValueChange('familyMembersDiagnosedWithCardiovascular', e.target.value)}
                      label="Family Member(s) Diagnosed"
                      selectOptions={getFamilyMembers()}
                      errors={errors && errors.familyMembersDiagnosedWithCardiovascular}
                      inputRef={register}
                    />
                  </Form.Group>

                  {(props.formState.familyMembersDiagnosedWithCardiovascular && props.formState.familyMembersDiagnosedWithCardiovascular.includes("Father")) &&
                    <Card className="pb-0 pt-3 px-3 mb-3">
                      <p className="formElementTitle">My father Passed away from cardiovascular/heart disease</p>
                      <Form.Group>
                        <StyledRadioInput
                          name="fatherPassedAwayByCardiovascular"
                          id="fatherPassedAwayByCardiovascular"
                          value={props.formState.fatherPassedAwayByCardiovascular}
                          options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                          onChange={e => handleValueChange('fatherPassedAwayByCardiovascular', e)}
                          errors={errors && errors.fatherPassedAwayByCardiovascular}
                          isBlankIcon={true}
                        />
                      </Form.Group>

                      {props.formState.fatherPassedAwayByCardiovascular === "Yes" &&
                        <Form.Group>
                          <SelectInput
                            name="fatherAgeOfDeathByCardiovascular"
                            id="fatherAgeOfDeathByCardiovascular"
                            aria-label="fatherAgeOfDeathByCardiovascular"
                            label="Father's Age of Death"
                            value={props.formState.fatherAgeOfDeathByCardiovascular}
                            onChange={e => handleValueChange('fatherAgeOfDeathByCardiovascular', e.target.value)}
                            inputRef={register}
                            errors={errors && errors.fatherAgeOfDeathByCardiovascular}
                            selectOptions={getAgeClasses()}
                          />
                        </Form.Group>
                      }

                      {props.formState.fatherPassedAwayByCardiovascular === "No" &&
                        <Form.Group>
                          <SelectInput
                            name="fatherAgeOfDiagnosisForCardiovascular"
                            id="fatherAgeOfDiagnosisForCardiovascular"
                            aria-label="fatherAgeOfDiagnosisForCardiovascular"
                            label="Father's Age of Diagnosis"
                            value={props.formState.fatherAgeOfDiagnosisForCardiovascular}
                            onChange={e => handleValueChange('fatherAgeOfDiagnosisForCardiovascular', e.target.value)}
                            inputRef={register}
                            errors={errors && errors.fatherAgeOfDiagnosisForCardiovascular}
                            selectOptions={getAgeClasses()}
                          />
                        </Form.Group>
                      }
                    </Card>
                  }

                  {(props.formState.familyMembersDiagnosedWithCardiovascular && props.formState.familyMembersDiagnosedWithCardiovascular.includes("Mother")) &&
                    <Card className="pb-0 pt-3 px-3  mb-3">
                      <p className="formElementTitle">My mother Passed away from cardiovascular/heart disease</p>
                      <Form.Group>
                        <StyledRadioInput
                          name="motherPassedAwayByCardiovascular"
                          id="motherPassedAwayByCardiovascular"
                          value={props.formState.motherPassedAwayByCardiovascular}
                          options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                          onChange={e => handleValueChange('motherPassedAwayByCardiovascular', e)}
                          errors={errors && errors.motherPassedAwayByCardiovascular}
                          isBlankIcon={true}
                        />
                      </Form.Group>

                      {props.formState.motherPassedAwayByCardiovascular === "Yes" &&
                        <Form.Group>
                          <SelectInput
                            name="motherAgeOfDeathByCardiovascular"
                            id="motherAgeOfDeathByCardiovascular"
                            aria-label="motherAgeOfDeathByCardiovascular"
                            label="Mother's Age of Death"
                            value={props.formState.motherAgeOfDeathByCardiovascular}
                            onChange={e => handleValueChange('motherAgeOfDeathByCardiovascular', e.target.value)}
                            inputRef={register}
                            errors={errors && errors.motherAgeOfDeathByCardiovascular}
                            selectOptions={getAgeClasses()}
                          />
                        </Form.Group>
                      }

                      {props.formState.motherPassedAwayByCardiovascular === "No" &&
                        <Form.Group>
                          <SelectInput
                            name="motherAgeOfDiagnosisForCardiovascular"
                            id="motherAgeOfDiagnosisForCardiovascular"
                            aria-label="motherAgeOfDiagnosisForCardiovascular"
                            label="Mother's Age of Diagnosis"
                            value={props.formState.motherAgeOfDiagnosisForCardiovascular}
                            onChange={e => handleValueChange('motherAgeOfDiagnosisForCardiovascular', e.target.value)}
                            inputRef={register}
                            errors={errors && errors.motherAgeOfDiagnosisForCardiovascular}
                            selectOptions={getAgeClasses()}
                          />
                        </Form.Group>
                      }
                    </Card>
                  }

                  {(props.formState.familyMembersDiagnosedWithCardiovascular && props.formState.familyMembersDiagnosedWithCardiovascular.includes("Sibling")) &&
                    <Card className="pb-0 pt-3 px-3 mb-3">
                      <p className="formElementTitle">My sibling Passed away from cardiovascular/heart disease</p>
                      <Form.Group>
                        <StyledRadioInput
                          name="siblingPassedAwayByCardiovascular"
                          id="siblingPassedAwayByCardiovascular"
                          value={props.formState.siblingPassedAwayByCardiovascular}
                          options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                          onChange={e => handleValueChange('siblingPassedAwayByCardiovascular', e)}
                          errors={errors && errors.siblingPassedAwayByCardiovascular}
                          isBlankIcon={true}
                        />
                      </Form.Group>

                      {props.formState.siblingPassedAwayByCardiovascular === "Yes" &&
                        <Form.Group>
                          <SelectInput
                            name="siblingAgeOfDeathByCardiovascular"
                            id="siblingAgeOfDeathByCardiovascular"
                            aria-label="siblingAgeOfDeathByCardiovascular"
                            label="Sibling's Age of Death"
                            value={props.formState.siblingAgeOfDeathByCardiovascular}
                            onChange={e => handleValueChange('siblingAgeOfDeathByCardiovascular', e.target.value)}
                            inputRef={register}
                            errors={errors && errors.siblingAgeOfDeathByCardiovascular}
                            selectOptions={getAgeClasses()}
                          />
                        </Form.Group>
                      }

                      {props.formState.siblingPassedAwayByCardiovascular === "No" &&
                        <Form.Group>
                          <SelectInput
                            name="siblingAgeOfDiagnosisForCardiovascular"
                            id="siblingAgeOfDiagnosisForCardiovascular"
                            aria-label="siblingAgeOfDiagnosisForCardiovascular"
                            label="Sibling's Age of Diagnosis"
                            value={props.formState.siblingAgeOfDiagnosisForCardiovascular}
                            onChange={e => handleValueChange('siblingAgeOfDiagnosisForCardiovascular', e.target.value)}
                            inputRef={register}
                            errors={errors && errors.siblingAgeOfDiagnosisForCardiovascular}
                            selectOptions={getAgeClasses()}
                          />
                        </Form.Group>
                      }
                    </Card>
                  }
                </Fragment>
              }
            </Col>
          </Row>

          <Row className="pre-quote-nav-control">
            <Col className="text-left btn-back">
              <Button variant="outlined" size="medium" color="primary" className="px-4" onClick={props.onBack}>
                BACK
              </Button>
            </Col>
            <Col className="text-right">
              <Button variant="contained" size="medium" color="primary" type="submit" className="px-4">
                NEXT
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>
    </ThemeProvider>
  );
}

FamilyHistory.propTypes = {
  formState: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};


FamilyHistory.ValidationSchema = object().shape({
  diagnosedWithCancer: string().required('Diagnosed With Cancer is required.'),
  familyMembersDiagnosedWithCancer: string().when("diagnosedWithCancer", {
    is: "Yes",
    then: string().required('Family Member Diagnosed For Cancer is required.'),
    otherwise: string().notRequired()
  }),

  fatherPassedAwayByCancer: string().when(["diagnosedWithCancer", "familyMembersDiagnosedWithCancer"], {
    is: (diagnosedWithCancer, familyMembersDiagnosedWithCancer) => diagnosedWithCancer === "Yes" && familyMembersDiagnosedWithCancer.includes('Father'),
    then: string().required("Father Passed By Cancer is required."),
    otherwise: string().notRequired()
  }),
  fatherAgeOfDeathByCancer: string().when(["diagnosedWithCancer", "familyMembersDiagnosedWithCancer", "fatherPassedAwayByCancer"], {
    is: (diagnosedWithCancer, familyMembersDiagnosedWithCancer, fatherPassedAwayByCancer) => diagnosedWithCancer === "Yes" && familyMembersDiagnosedWithCancer.includes('Father') && fatherPassedAwayByCancer === "Yes",
    then: string().required('Age is required.'),
    otherwise: string().notRequired()
  }),
  fatherAgeOfDiagnosisForCancer: string().when(["diagnosedWithCancer", "familyMembersDiagnosedWithCancer", "fatherPassedAwayByCancer"], {
    is: (diagnosedWithCancer, familyMembersDiagnosedWithCancer, fatherPassedAwayByCancer) => diagnosedWithCancer === "Yes" && familyMembersDiagnosedWithCancer.includes('Father') && fatherPassedAwayByCancer === "No",
    then: string().required('Age is required.'),
    otherwise: string().notRequired()
  }),

  motherPassedAwayByCancer: string().when(["diagnosedWithCancer", "familyMembersDiagnosedWithCancer"], {
    is: (diagnosedWithCancer, familyMembersDiagnosedWithCancer) => diagnosedWithCancer === "Yes" && familyMembersDiagnosedWithCancer.includes('Mother'),
    then: string().required("Mother Passed By Cancer is required."),
    otherwise: string().notRequired()
  }),
  motherAgeOfDeathByCancer: string().when(["diagnosedWithCancer", "familyMembersDiagnosedWithCancer", "motherPassedAwayByCancer"], {
    is: (diagnosedWithCancer, familyMembersDiagnosedWithCancer, motherPassedAwayByCancer) => diagnosedWithCancer === "Yes" && familyMembersDiagnosedWithCancer.includes('Mother') && motherPassedAwayByCancer === "Yes",
    then: string().required('Age is required.'),
    otherwise: string().notRequired()
  }),
  motherAgeOfDiagnosisForCancer: string().when(["diagnosedWithCancer", "familyMembersDiagnosedWithCancer", "motherPassedAwayByCancer"], {
    is: (diagnosedWithCancer, familyMembersDiagnosedWithCancer, motherPassedAwayByCancer) => diagnosedWithCancer === "Yes" && familyMembersDiagnosedWithCancer.includes('Mother') && motherPassedAwayByCancer === "No",
    then: string().required('Age is required.'),
    otherwise: string().notRequired()
  }),

  siblingPassedAwayByCancer: string().when(["diagnosedWithCancer", "familyMembersDiagnosedWithCancer"], {
    is: (diagnosedWithCancer, familyMembersDiagnosedWithCancer) => diagnosedWithCancer === "Yes" && familyMembersDiagnosedWithCancer.includes('Sibling'),
    then: string().required("Sibling Passed By Cancer is required."),
    otherwise: string().notRequired()
  }),
  siblingAgeOfDeathByCancer: string().when(["diagnosedWithCancer", "familyMembersDiagnosedWithCancer", "siblingPassedAwayByCancer"], {
    is: (diagnosedWithCancer, familyMembersDiagnosedWithCancer, siblingPassedAwayByCancer) => diagnosedWithCancer === "Yes" && familyMembersDiagnosedWithCancer.includes('Sibling') && siblingPassedAwayByCancer === "Yes",
    then: string().required('Age is required.'),
    otherwise: string().notRequired()
  }),
  siblingAgeOfDiagnosisForCancer: string().when(["diagnosedWithCancer", "familyMembersDiagnosedWithCancer", "siblingPassedAwayByCancer"], {
    is: (diagnosedWithCancer, familyMembersDiagnosedWithCancer, siblingPassedAwayByCancer) => diagnosedWithCancer === "Yes" && familyMembersDiagnosedWithCancer.includes('Sibling') && siblingPassedAwayByCancer === "No",
    then: string().required('Age is required.'),
    otherwise: string().notRequired()
  }),

  diagnosedWithCardiovascular: string().required('Diagnosed With Cardiovascular is required.'),
  familyMembersDiagnosedWithCardiovascular: string().when("diagnosedWithCardiovascular", {
    is: "Yes",
    then: string().required('Family Member Diagnosed For Cardiovascular is required.'),
    otherwise: string().notRequired()
  }),

  fatherPassedAwayByCardiovascular: string().when(["diagnosedWithCardiovascular", "familyMembersDiagnosedWithCardiovascular"], {
    is: (diagnosedWithCardiovascular, familyMembersDiagnosedWithCardiovascular) => diagnosedWithCardiovascular === "Yes" && familyMembersDiagnosedWithCardiovascular.includes('Father'),
    then: string().required("Father Passed By Cardiovascular is required."),
    otherwise: string().notRequired()
  }),
  fatherAgeOfDeathByCardiovascular: string().when(["diagnosedWithCardiovascular", "familyMembersDiagnosedWithCardiovascular", "fatherPassedAwayByCardiovascular"], {
    is: (diagnosedWithCardiovascular, familyMembersDiagnosedWithCardiovascular, fatherPassedAwayByCardiovascular) => diagnosedWithCardiovascular === "Yes" && familyMembersDiagnosedWithCardiovascular.includes('Father') && fatherPassedAwayByCardiovascular === "Yes",
    then: string().required('Age is required.'),
    otherwise: string().notRequired()
  }),
  fatherAgeOfDiagnosisForCardiovascular: string().when(["diagnosedWithCardiovascular", "familyMembersDiagnosedWithCardiovascular", "fatherPassedAwayByCardiovascular"], {
    is: (diagnosedWithCardiovascular, familyMembersDiagnosedWithCardiovascular, fatherPassedAwayByCardiovascular) => diagnosedWithCardiovascular === "Yes" && familyMembersDiagnosedWithCardiovascular.includes('Father') && fatherPassedAwayByCardiovascular === "No",
    then: string().required('Age is required.'),
    otherwise: string().notRequired()
  }),

  motherPassedAwayByCardiovascular: string().when(["diagnosedWithCardiovascular", "familyMembersDiagnosedWithCardiovascular"], {
    is: (diagnosedWithCardiovascular, familyMembersDiagnosedWithCardiovascular) => diagnosedWithCardiovascular === "Yes" && familyMembersDiagnosedWithCardiovascular.includes('Mother'),
    then: string().required("Mother Passed By Cardiovascular is required."),
    otherwise: string().notRequired()
  }),
  motherAgeOfDeathByCardiovascular: string().when(["diagnosedWithCardiovascular", "familyMembersDiagnosedWithCardiovascular", "motherPassedAwayByCardiovascular"], {
    is: (diagnosedWithCardiovascular, familyMembersDiagnosedWithCardiovascular, motherPassedAwayByCardiovascular) => diagnosedWithCardiovascular === "Yes" && familyMembersDiagnosedWithCardiovascular.includes('Mother') && motherPassedAwayByCardiovascular === "Yes",
    then: string().required('Age is required.'),
    otherwise: string().notRequired()
  }),
  motherAgeOfDiagnosisForCardiovascular: string().when(["diagnosedWithCardiovascular", "familyMembersDiagnosedWithCardiovascular", "motherPassedAwayByCardiovascular"], {
    is: (diagnosedWithCardiovascular, familyMembersDiagnosedWithCardiovascular, motherPassedAwayByCardiovascular) => diagnosedWithCardiovascular === "Yes" && familyMembersDiagnosedWithCardiovascular.includes('Mother') && motherPassedAwayByCardiovascular === "No",
    then: string().required('Age is required.'),
    otherwise: string().notRequired()
  }),

  siblingPassedAwayByCardiovascular: string().when(["diagnosedWithCardiovascular", "familyMembersDiagnosedWithCardiovascular"], {
    is: (diagnosedWithCardiovascular, familyMembersDiagnosedWithCardiovascular) => diagnosedWithCardiovascular === "Yes" && familyMembersDiagnosedWithCardiovascular.includes('Sibling'),
    then: string().required("Sibling Passed By Cardiovascular is required."),
    otherwise: string().notRequired()
  }),
  siblingAgeOfDeathByCardiovascular: string().when(["diagnosedWithCardiovascular", "familyMembersDiagnosedWithCardiovascular", "siblingPassedAwayByCardiovascular"], {
    is: (diagnosedWithCardiovascular, familyMembersDiagnosedWithCardiovascular, siblingPassedAwayByCardiovascular) => diagnosedWithCardiovascular === "Yes" && familyMembersDiagnosedWithCardiovascular.includes('Sibling') && siblingPassedAwayByCardiovascular === "Yes",
    then: string().required('Age is required.'),
    otherwise: string().notRequired()
  }),
  siblingAgeOfDiagnosisForCardiovascular: string().when(["diagnosedWithCardiovascular", "familyMembersDiagnosedWithCardiovascular", "siblingPassedAwayByCardiovascular"], {
    is: (diagnosedWithCardiovascular, familyMembersDiagnosedWithCardiovascular, siblingPassedAwayByCardiovascular) => diagnosedWithCardiovascular === "Yes" && familyMembersDiagnosedWithCardiovascular.includes('Sibling') && siblingPassedAwayByCardiovascular === "No",
    then: string().required('Age is required.'),
    otherwise: string().notRequired()
  }),
})


FamilyHistory.DefaultFormState = (prefill = false) => {
  return {
    diagnosedWithCancer: '',
    familyMembersDiagnosedWithCancer: '',
    fatherPassedAwayByCancer: '',
    fatherAgeOfDeathByCancer: '',
    fatherAgeOfDiagnosisForCancer: '',
    motherPassedAwayByCancer: '',
    motherAgeOfDeathByCancer: '',
    motherAgeOfDiagnosisForCancer: '',
    siblingPassedAwayByCancer: '',
    siblingAgeOfDeathByCancer: '',
    siblingAgeOfDiagnosisForCancer: '',

    diagnosedWithCardiovascular: '',
    familyMembersDiagnosedWithCardiovascular: '',
    fatherPassedAwayByCardiovascular: '',
    fatherAgeOfDeathByCardiovascular: '',
    fatherAgeOfDiagnosisForCardiovascular: '',
    motherPassedAwayByCardiovascular: '',
    motherAgeOfDeathByCardiovascular: '',
    motherAgeOfDiagnosisForCardiovascular: '',
    siblingPassedAwayByCardiovascular: '',
    siblingAgeOfDeathByCardiovascular: '',
    siblingAgeOfDiagnosisForCardiovascular: '',
  };
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Common/FamilyHistory.js